import React, { useEffect, useState } from 'react';
import { Outlet, useParams, Link } from 'react-router-dom';
import { OrgProvider } from '../context/OrgContext';
import { getOrganizationBySlug } from '../services/organizationService';

const OrgLayout = () => {
  const { orgSlug } = useParams();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getOrganizationBySlug(orgSlug)
      .then((data) => {
        if (!cancelled) setOrg(data);
      })
      .catch((err) => {
        if (!cancelled) {
          if (err.response?.status === 404) {
            setError('not_found');
          } else {
            setError('network');
          }
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [orgSlug]);

  if (loading) {
    return (
      <div style={{ padding: 60, textAlign: 'center' }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  if (error === 'not_found' || !org) {
    return (
      <div style={{ padding: 60, maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
        <h2>Organization not found</h2>
        <p style={{ color: '#666', marginTop: 12 }}>
          No organization exists at <code>/o/{orgSlug}</code>. Check the URL or contact your restaurant.
        </p>
        <Link to="/" className="btn btn-primary mt-3">Back to Home</Link>
      </div>
    );
  }

  if (error === 'network') {
    return (
      <div style={{ padding: 60, maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
        <h2>Something went wrong</h2>
        <p style={{ color: '#666', marginTop: 12 }}>Couldn't load organization info. Please try again.</p>
        <button className="btn btn-primary mt-3" onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <OrgProvider org={org}>
      <Outlet />
    </OrgProvider>
  );
};

export default OrgLayout;
